import React from "react";
import { useTranslation } from 'react-i18next';
import { ChevronRightIcon, ChevronLeftIcon } from '@heroicons/react/20/solid';
import { sectionStyles } from '../styles/globalStyles';

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import certificates from '../data/certificates.js';

const Certificates = () => {
    const { t } = useTranslation();

    const NextArrow = (props) => {
        const { style, onClick } = props;
        return (
            <div
                className={"slick-arrow slick-next w-16 h-16"}
                style={{ ...style, display: 'block', right: 0, zIndex: 10, cursor: 'pointer' }}
                onClick={onClick}
            >
                <ChevronRightIcon className="w-16 h-16 text-gray-700 dark:text-gray-300" />
            </div>
        );
    };

    const PrevArrow = (props) => {
        const { style, onClick } = props;
        return (
            <div
                className={"slick-arrow slick-prev w-16 h-16"}
                style={{ ...style, display: 'block', left: -44, zIndex: 10, cursor: 'pointer' }}
                onClick={onClick}
            >
                <ChevronLeftIcon className="w-16 h-16 text-gray-700 dark:text-gray-300" />
            </div>
        );
    };

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 3000,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        adaptativeHeight: false,
        dotsClass: "slick-dots !bottom-[-50px] md:!bottom-[-80px] mb-4",
        customPaging: function (i) {
            return (
                <button type="button" className="custom-dot-button"></button>
            );
        },
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    };

    return (
        <section id="certificates" className={sectionStyles.section}>
            <div className={sectionStyles.container}>
                <div className={sectionStyles.title}>
                    <p className={sectionStyles.breadcrumb}>
                        <ChevronRightIcon className="w-4 h-4 mr-2" />
                        {t('certificates.title')}
                    </p>
                    <h2 className={sectionStyles.heading}>
                        {t('certificates.subtitle')}
                    </h2>
                </div>

                <Slider {...settings} className="mb-28">
                    {certificates.map(({ id, image, subtitleKey, date, provider, link }) => (
                        <div key={id} className="p-3">
                            <div className="stamp-outer flex flex-col h-full"> 
                                <div className="stamp-inner p-6 flex flex-col flex-grow h-[400px]"> 
                                    <img
                                        src={image}
                                        alt={t(subtitleKey)}
                                        className="w-full h-40 object-contain mb-4"
                                    />
                                    <h3 className="text-lg font-semibold mb-2">{t(subtitleKey)}</h3>
                                    <small className="mb-1">{t(date)}</small>
                                    <span className="mb-4">{t(provider)}</span>
                                    <a
                                        href={link}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="mt-auto inline-block"
                                    >
                                        {t('certificates.cta')} <ChevronRightIcon className="inline w-4 h-4" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    ))}
                </Slider>
            </div>
        </section>
    );
};

export default Certificates;
